var map = {
	"./Bihar/Bihar_image_1.jpg": 7945,
	"./Bihar/Bihar_image_2.jpg": 8895,
	"./Bihar/Bihar_image_3.jpg": 554,
	"./Bihar/Bihar_image_4.jpg": 6844,
	"./delhi/delhi_image_1.jpg": 3395,
	"./delhi/delhi_image_2.jpg": 7615,
	"./delhi/delhi_image_3.jpg": 5765,
	"./karnataka/karnataka_image_1.jpg": 5237,
	"./karnataka/karnataka_image_2.jpg": 4498,
	"./kolkata/kolkata_image_1.jpg": 2513,
	"./kolkata/kolkata_image_2.jpg": 1284,
	"./kolkata/kolkata_image_3.jpg": 7323,
	"./kolkata/kolkata_image_4.jpg": 740,
	"./kolkata/kolkata_image_5.jpg": 4679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5796;